<section class="dashboard container-fluid py-2">
  <div class="card shadow-sm mb-3"><div class="card-body"><h1 class="h3 mb-0">Panel de Control</h1></div></div>
  <div class="row g-3">
    @for (module of modules(); track module.path) {
      <div class="col-12 col-sm-6 col-xl-4">
        <a class="card dashboard-card h-100 shadow-sm text-decoration-none" [routerLink]="module.path">
          <div class="card-body d-flex align-items-center gap-3">
            <span class="dashboard-icon text-primary"><i [class]="'bi ' + module.icon"></i></span>
            <div class="flex-grow-1"><h2 class="h6 mb-1 text-body">{{ module.title }}</h2><span class="text-body-secondary small">Registros</span></div>
            <strong class="display-6 text-primary">{{ module.count ?? '—' }}</strong>
          </div>
        </a>
      </div>
    }
  </div>
  @if (loading()) { <p class="text-body-secondary small mt-3 mb-0">Actualizando conteos…</p> }
</section>
